export const customGlCodeAssignmentsEn = {
  GL_CODE_ASSIGNMENT: 'GL Code Assignment',
  GL_CODE_ASSIGNMENT_ACCOUNTS_TITLE: 'Accounts',
  GL_CODE_ASSIGNMENT_SELECT_ACCOUNT_PROMPT: 'Select an account to see its payment types.',
  GL_CODE_ASSIGNMENT_DESCRIPTION:
    "This is entirely optional. Assign a custom GL code to any payment type below whenever it's convenient — anything you leave alone keeps using your default GL code, so there's nothing you need to do here.",
  GL_CODE_ASSIGNMENT_USING_DEFAULT: 'Using default',
  GL_CODE_ASSIGNMENT_CREATE_TOOLTIP: 'Create a new custom GL code and assign it here',
  GL_CODE_ASSIGNMENT_ASSIGNED_SUCCESSFULLY: 'Custom GL code assigned successfully',
  GL_CODE_ASSIGNMENT_UPDATED_SUCCESSFULLY: 'Custom GL code assignment updated successfully',
  GL_CODE_ASSIGNMENT_RESET_SUCCESSFULLY: 'Payment type reverted to the default GL code',
  GL_CODE_ASSIGNMENT_NO_ACCOUNTS: 'No accounts found',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_TOOLTIP: 'Apply this GL code to every payment type for this account',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_CONFIRM_TITLE: 'Apply to all payment types?',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_CONFIRM_BODY:
    'This replaces the custom GL code on every payment type for this direction with the one selected here. This cannot be undone automatically.',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_SUCCESSFULLY: 'Applied this GL code to every payment type for this direction',
  GL_CODE_ASSIGNMENT_NO_LONGER_ELIGIBLE: 'no longer eligible',
  GL_CODE_ASSIGNMENT_CREATE_AND_ASSIGN: 'Create & Assign',
  GL_CODE_ASSIGNMENT_TAB_INBOUND: 'Received Payments',
  GL_CODE_ASSIGNMENT_TAB_OUTBOUND: 'Funding',
  GL_CODE_ASSIGNMENT_TAB_RETURNED: 'Returned Payments',
}

export const customGlCodeAssignmentsEs: typeof customGlCodeAssignmentsEn = {
  GL_CODE_ASSIGNMENT: 'Asignación de Códigos GL',
  GL_CODE_ASSIGNMENT_ACCOUNTS_TITLE: 'Cuentas',
  GL_CODE_ASSIGNMENT_SELECT_ACCOUNT_PROMPT: 'Selecciona una cuenta para ver sus tipos de pago.',
  GL_CODE_ASSIGNMENT_DESCRIPTION:
    'Esto es completamente opcional. Asigná un código GL personalizado a cualquier tipo de pago cuando te resulte conveniente — lo que dejes sin tocar sigue usando tu código GL default, así que no hay nada que debas hacer aquí.',
  GL_CODE_ASSIGNMENT_USING_DEFAULT: 'Usando el default',
  GL_CODE_ASSIGNMENT_CREATE_TOOLTIP: 'Crear un nuevo código GL personalizado y asignarlo aquí',
  GL_CODE_ASSIGNMENT_ASSIGNED_SUCCESSFULLY: 'Código GL personalizado asignado con éxito',
  GL_CODE_ASSIGNMENT_UPDATED_SUCCESSFULLY: 'Asignación de código GL actualizada con éxito',
  GL_CODE_ASSIGNMENT_RESET_SUCCESSFULLY: 'El tipo de pago volvió a usar el código GL default',
  GL_CODE_ASSIGNMENT_NO_ACCOUNTS: 'No se encontraron cuentas',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_TOOLTIP: 'Aplicar este código GL a todos los tipos de pago de esta cuenta',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_CONFIRM_TITLE: '¿Aplicar a todos los tipos de pago?',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_CONFIRM_BODY:
    'Esto reemplaza el código GL personalizado de todos los tipos de pago de esta dirección con el seleccionado aquí. Esta acción no se puede deshacer automáticamente.',
  GL_CODE_ASSIGNMENT_COPY_TO_ALL_SUCCESSFULLY: 'Se aplicó este código GL a todos los tipos de pago de esta dirección',
  GL_CODE_ASSIGNMENT_NO_LONGER_ELIGIBLE: 'ya no es elegible',
  GL_CODE_ASSIGNMENT_CREATE_AND_ASSIGN: 'Crear y Asignar',
  GL_CODE_ASSIGNMENT_TAB_INBOUND: 'Pagos Recibidos',
  GL_CODE_ASSIGNMENT_TAB_OUTBOUND: 'Financiamiento',
  GL_CODE_ASSIGNMENT_TAB_RETURNED: 'Pagos Devueltos',
}
